/**
 * AdminOAuthProviderRpcClient - AtomRpc integration for admin OAuth provider endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOAuthProviderRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOAuthProviderRpcClient extends AtomRpc.Tag<AdminOAuthProviderRpcClient>()(
  "AdminOAuthProviderRpcClient",
  {
    group: AdminOAuthProviderRpcs,
    protocol: makeRpcClientLayer(AdminOAuthProviderRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
